import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../hoc/compose';
import displayNames from '../displayNames';
import Tab from './tab';
import RadioButtons from '../radioButtons/radioButtons';
import Divider from '../divider/divider';

var isEmptyObj = function isEmptyObj(passedObj) {
  return !(passedObj && passedObj === Object(passedObj) && Object.keys(passedObj).length !== 0);
};

var validateOptions = function validateOptions(props, propName, compName, locationName) {
  if (isEmptyObj(props[propName]) === isEmptyObj(props.children)) {
    return new Error("Exactly one of ".concat(propName, " property and children can be specified in ").concat(compName, "."));
  }

  var optionsType = {
    options: PropTypes.arrayOf(PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    }))
  };
  PropTypes.checkPropTypes(optionsType, props, locationName, compName);
};

var DIVIDER_VALUE = '__DIVIDER__';

var generateTabs = function generateTabs(props) {
  return props.options.map(function (tabProps, index) {
    var key = "tab".concat(index);

    if (tabProps.value === DIVIDER_VALUE) {
      return /*#__PURE__*/React.createElement(Divider, {
        key: key
      });
    }

    return /*#__PURE__*/React.createElement(Tab, {
      shouldTranslate: props.shouldTranslate,
      automationId: tabProps.automationId,
      showDotIndicator: tabProps.showDotIndicator,
      dataHook: tabProps.dataHook,
      label: tabProps.label,
      value: tabProps.value,
      key: key
    });
  });
};

var VerticalTabs = /*#__PURE__*/function (_React$Component) {
  _inherits(VerticalTabs, _React$Component);

  var _super = _createSuper(VerticalTabs);

  function VerticalTabs(props) {
    var _this;

    _classCallCheck(this, VerticalTabs);

    _this = _super.call(this, props);

    _this.generateTabs = function () {
      return _this.props.children || generateTabs(_this.props);
    };

    _this.radioItemPredicate = function (item) {
      return item.type.getDisplayName !== undefined && item.type.getDisplayName() === displayNames.TAB;
    };

    return _this;
  }

  _createClass(VerticalTabs, [{
    key: "getStyleVariables",
    value: function getStyleVariables() {
      var _this$props = this.props,
          maxWidth = _this$props.maxWidth,
          accentColor = _this$props.accentColor;
      return _objectSpread(_objectSpread({}, maxWidth && {
        '--vertical-tabs-custom-pane-max-width': "".concat(maxWidth, "px")
      }), accentColor && {
        '--vertical-tabs-custom-accent-color': accentColor
      });
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        "data-hook": this.props.dataHook,
        className: classNames(this.props.getClassName('control-vertical-tabs'), {
          'arrowed-box': this.props.arrowedBox,
          'with-color-accent': this.props.accentColor !== VerticalTabs.defaultProps.accentColor
        }),
        style: this.getStyleVariables()
      }, /*#__PURE__*/React.createElement(RadioButtons, {
        value: this.props.value,
        showRadioSymbol: false,
        radioItemPredicate: this.radioItemPredicate,
        onChange: this.props.onChange
      }, this.generateTabs()));
    }
  }]);

  return VerticalTabs;
}(React.Component);

VerticalTabs.displayName = displayNames.VERTICAL_TABS;
VerticalTabs.propTypes = {
  /** selected tab value */
  value: PropTypes.string.isRequired,

  /** a callback called on tab click with the newly selected option's `value` */
  onChange: PropTypes.func.isRequired,

  /** arrowed box to cover selected tab (hides tabs value and places indexes) */
  arrowedBox: PropTypes.bool,

  /** list of all tabs - [{value, label}] */
  options: validateOptions,

  /** max width of tabs pane **/
  maxWidth: PropTypes.number,

  /** primary color which is directly translated to pane background color **/
  accentColor: PropTypes.string
};
VerticalTabs.defaultProps = {
  arrowedBox: false
};
export default Object.assign(compose(VerticalTabs), {
  DIVIDER_VALUE: DIVIDER_VALUE
});